module.exports = __webpack_public_path__ + "media/assets/consultation/budget_15000-c9a7f34668b5fe7250d830bb70a0d26f.svg";